<template>
  <div class="animated fadeIn pt-3">
    <b-row v-if="loadingPage && this.$route.params.id != undefined">
      <h3>Cargando Contenido ...</h3>
    </b-row>
    <b-row v-if="!loadingPage || this.$route.params.id == undefined">
      <b-col lg="12">
        <transition name="fade">
          <!--<b-card :style="{ background: `hsla(${color.hue}deg, 80%, 60%, 1)` }">-->

          <b-card>
            <div slot="header">
              <strong>Constructor de Material</strong>
              <div class="card-header-actions">
                <b-link
                  v-if="!forUpdate"
                  class="card-header-action"
                  @click="onSave('save')"
                  v-b-popover.hover.top="'Guarda el contenido del Material'"
                  variant="primary"
                >
                  <font-awesome-icon icon="save" />&nbsp; Guardar
                </b-link>
                <b-link v-else class="card-header-action" @click="onSave('edit')">
                  <font-awesome-icon icon="save" />&nbsp; Actualizar
                </b-link>
                <b-link
                  class="card-header-action"
                  v-b-popover.hover.top="'Visualiza el contenido del material antes de guardar'"
                  variant="primary"
                  @click="activePreview"
                >
                  <font-awesome-icon icon="play" />&nbsp; Vista Previa
                </b-link>
              </div>
            </div>
            <!--
        <b-row v-show='toggle1' class="justify-content-md-center">
          <b-col cols="12" md="auto"><h3>Elija un color de fondo</h3></b-col>
          <b-col col lg="2"> <swatches v-model="backgroundColorr" close-on-select class="swatches" colors="text-advanced" popover-to="right"></swatches></b-col>
        </b-row>
            -->
            <div id="cabecera" class="container-fluid constructor-area">
              <b-row>
                <b-col lg="12" class="display-4 titulo-main">
                  <ckeditor
                    :editor="optsTitleEditor.editor"
                    v-model="titleEditor"
                    :config="optsTitleEditor.editorConfig"
                  ></ckeditor>
                </b-col>
                <!--<b-col lg="12">
              <ckeditor :editor="optsDescEditor.editor" v-model="descEditor" :config="optsDescEditor.editorConfig"></ckeditor>
                </b-col>-->
              </b-row>
            </div>
            <div
              v-on:drop="drop($event)"
              v-on:dragover="allowDrop($event)"
              v-on:dragenter="dragEnter($event)"
              id="mainContainer"
              class="container-fluid constructor-area"
              ref="mainContainer"
            >
              <draggable v-model="elements" group="people" @start="drag=true" @end="drag=false">
                <component
                  v-for="(el,index) in elements"
                  :key="el.index"
                  :is="el.tag"
                  v-bind="elementPropierties(el, index, el.id)"
                ></component>
                <div>
                  <b-col class="empty-folder animated fadeIn text-center">
                    <p>
                      <span
                        style="vertical-align: middle;"
                      >Seleccione un Elemento de la Barra de Herramientas para Construir su Sesión</span>
                      <font-awesome-icon
                        icon="hand-point-right"
                        size="2x"
                        class="icon-hand-right animated infinite heartBeat color-icon-point"
                      />
                    </p>
                  </b-col>
                </div>
              </draggable>
            </div>
            <!--
    <b-button variant="success" class="float" v-b-tooltip.hover title="Click Para Color de Fondo" @click='toggle1 = !toggle1'>
      <font-awesome-icon icon="palette" size="3x" />
    </b-button>
            -->
            <!--
  <color-picker v-bind="color" :initially-collapsed="true"  class="float" v-b-tooltip.hover title="Click Para Color de Fondo"  @input="onInput"></color-picker>
            -->
            <!-- <div class="container">
              <b-row>
                <b-col lg="12" class="actividad-pre-container">
                  <div class="text-center btn-add-element" 
                   v-b-popover.hover.top="'Muestra / Oculta la Barra de Elementos'"
                   variant="primary" 
                   @click="sidebarToggle($event)" 
                  >
                    <i class="icon-plus"></i>
                    <br>Agregue Elemento
                  </div>
                </b-col>
              </b-row>
            </div>
            <div id="pie" class="container-fluid constructor-area"></div>-->
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <modal-save-as :target="tgModalSaveAs" @ModalSaveAsClosed="tgModalSaveAs = false" />
    
  </div>
</template>


<script>
import InlineEditor from "@ckeditor/ckeditor5-build-inline";
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";
import ColorPicker from "@radial-color-picker/vue-color-picker";
import {
  sidebarCssClasses,
  asideMenuCssClasses,
  validBreakpoints,
  checkBreakpoint
} from "@coreui/vue/src/shared/classes";
import toggleClasses from "@coreui/vue/src/shared/toggle-classes";
import DirectorioService from "@/services/directorio.service";
import MaterialService from "@/services/material.service";
import draggable from "vuedraggable";
import ModalSaveAs from "@/components/ModalSaveAs";
// componentes del constructor
import Parrafo from "@/components/constructor/Parrafo";
import Separator from "@/components/constructor/Separator";
import Tabla from "@/components/constructor/Tabla";
import Columnas from "@/components/constructor/Columnas";
import Recurso from "@/components/constructor/Recurso";
import QuizContent from "@/components/constructor/QuizContent";
import RelacionarContent from "@/components/constructor/RelacionarContent";
import FlashCards from "@/components/constructor/FlashCards";
import OrdenaFrase from "@/components/constructor/OrdenaFrase";
import Sopa from "@/components/constructor/Sopa";
import HangMan from "@/components/constructor/HangMan";
import Animales from "@/components/constructor/Animales";
import Loteria from "@/components/constructor/Loteria";
import CompletarFrase from "@/components/constructor/CompletarFrase";
import Memorama from "@/components/constructor/Memorama";
import Subtitulo from "@/components/constructor/Subtitulo";
import Crucigrama from "@/components/constructor/Crucigrama";
import Dot from "@/components/constructor/Dot";


export default {
  name: "Constructor",
  beforeRouteLeave(to, from, next) {
    console.log(to);
    if (to.name != "Preview") {
      this.$swal
        .fire({
          text:
            "¿Está seguro de querer salir del Constructor?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: 'Sí, Salir',
          cancelButtonText: "No, Continuar"
        })
        .then(result => {
          if (result.value) {
            next();
          }
        })
        .catch(result => {
          next(false);
        });
    } else {
      next();
    }
  },
  components: {
    Parrafo,
    Separator,
    Tabla,
    Columnas,
    Recurso,
    draggable,
    QuizContent,
    RelacionarContent,
    FlashCards,
    OrdenaFrase,
    Sopa,
    Swatches,
    ColorPicker,
    HangMan,
    Animales,
    Loteria,
    CompletarFrase,
    ModalSaveAs,
    Memorama,
    Subtitulo,
    Crucigrama,
    Dot,
  },
  data() {
    return {
      optsTitleEditor: {
        editor: InlineEditor,
        editorConfig: {
          toolbar: [
            "heading",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "alignment"
          ],
          placeholder: "Título de la Sesión"
        }
      },
      /*optsDescEditor: {
      editor: InlineEditor,
      editorConfig: {
        toolbar: ['heading', '|', 'fontSize','fontFamily' ,'fontColor','fontBackgroundColor', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', 'blockQuote', 'alignment'],
        placeholder: "Descripción de la Sesión"
      }
    },*/
      color: this.$store.getters["constructor/getColor"] || {
        hue: 30,
        saturation: 100,
        luminosity: 50,
        alpha: 1
      },
      toggle1: false,
      titleEditor: this.$store.getters["constructor/getTitle"] || "<p></p>",
      descEditor: this.$store.getters["constructor/getDesc"] || "<h3></h3>",
      user: this.$store.getters["auth/infoUser"],
      dataMaterial: {
        title: this.titleEditor,
        name: "",
        description: this.descEditor,
        color: this.color,
        author: null,
        father: null,
        tree: [],
        content: this.elements
      },
      listMaterias: new Array(),
      tgModalSaveAs: false,
      lastTargetId: undefined,
      loadingPage: true
    };
  },
  methods: {
    onEditorReady(editor) {
      // Display all toolbar items.
      console.log(Array.from(editor.ui.componentFactory.names()));
    },
    dragEnter(ev) {
      this.lastTargetId = ev.target.id ? ev.target.id : this.lastTargetId;
      console.log(this.lastTargetId);
    },
    onInput: function(hue) {
      this.color.hue = hue;
    },
    drop(ev) {
      var rawData = ev.dataTransfer.getData("txt-json") || undefined;
      if (rawData) {
        var data = JSON.parse(rawData);
        console.log("Data parsed: ", data);
        if (data.bS)
          this.$store.dispatch(
            "constructor/insertElementInBlock",
            data.element
          );
        else this.$store.dispatch("constructor/insertElement", data.element);

        var bodys = this.$store.getters["constructor/getBodyElements"];
        if (bodys.length > 1) {
          var srcIdIndex = undefined;
          for (var i = 0; i < bodys.length; i++)
            if (data.element.id == bodys[i].id) {
              srcIdIndex = i;
              break;
            }
          bodys.splice(srcIdIndex, 1);
          if (
            /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
              this.lastTargetId
            )
          ) {
            var trgIdIndex = undefined;
            for (var i = 0; i < bodys.length; i++) {
              if (this.lastTargetId && this.lastTargetId == bodys[i].id) {
                trgIdIndex = i;
                break;
              }
            }
            if (trgIdIndex >= 0) {
              bodys.splice(trgIdIndex, 0, data.element);
            } else {
              bodys.push(data.element);
            }
          } else {
            bodys.push(data.element);
          }
        }
      }
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    elementPropierties(el, index, id) {
      let propierties = {};
      switch (el.tag) {
        case "Parrafo":
          propierties = {
            content: el.content,
            idElement: index
          };
          break;
        case "Separator":
          propierties = {
            content: el.content,
            idElement: index
          };
          break;
        case "Tabla":
          propierties = {
            content: el.content,
            idElement: index
          };
          break;
        case "Columnas":
          propierties = {
            columnas: el.columns,
            idElement: index
          };
          break;
        case "Recurso":
          propierties = {
            recursoSelected: el.file,
            idElement: index,
            tipo: el.type
          };
          break;
        case "QuizContent":
          propierties = {
            preguntas: el.preguntas,
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "RelacionarContent":
          propierties = {
            elementos: el.elementos,
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "FlashCards":
          propierties = {
            cartas: el.cartas,
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "Sopa":
          propierties = {
            palabras: el.palabras,
            desc: el.instrucciones,
            idElement: index,
            size: el.size
          };
          break;
        case "OrdenaFrase":
          propierties = {
            frases: el.frases,
            desc: el.instrucciones,
            idElement: index
          };
        case "Animales":
          propierties = {
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "HangMan":
          propierties = {
            palabras: el.palabras,
            desc: el.instrucciones,
            idElement: index
          };
          break;

        case "CompletarFrase":
          propierties = {
            desc: el.instrucciones,
            idElement: index,
            texto: el.lectura
          };
          break;
        case "Loteria":
          propierties = {
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "Memorama":
          propierties = {
            cartas: el.cartas,
            desc: el.instrucciones,
            idElement: index
          };
          break;
        case "Subtitulo":
          propierties = {
            content: el.content,
            idElement: index,
            configuraciones: el.config
          };
          break;
        case "Crucigrama":
          propierties = {
            content: el.content,
            idElement: index,
            palabras: el.palabras,
            desc: el.instrucciones,
            matrix: el.matrix,
            horizontal: el.horizontal,
            vertical: el.vertical
          };
          break;
        case "Dot":
          propierties = {
            content: el.content,
            idElement: index,
            desc: el.instrucciones,
            points: el.points,
            recursoSelected: el.file
          };
          break;
      }
      propierties.id = id;
      return propierties;
    },
    toggle(force) {
      const [display, mobile] = [this.display, this.mobile];
      let cssClass = asideMenuCssClasses[0];
      if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
        cssClass = `aside-menu-${display}-show`;
      }
      toggleClasses(cssClass, asideMenuCssClasses, force);
    },
    sidebarToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    },
    activePreview() {
      //this.$store.dispatch('constructor/activePreview');
      console.log(this.dataMaterial.color);
      this.$router.push({ name: "Preview", params: { id: "dev" } });
    },
    deactivePreview() {
      this.$store.dispatch("constructor/deactivePreview");
    },
    onSave(typeAction = "save") {
      let dataMaterial = this.$store.getters["constructor/getActivityData"];
      this.dataMaterial = dataMaterial.info;
      this.dataMaterial.content = this.elements;
      if (typeAction == "save") {
        this.dataMaterial.author = this.user._id;
        if (this.dataMaterial.father) {
          this.$swal
            .fire({
              title: "Guardar material como...",
              input: "text",
              inputAttributes: {
                autocapitalize: "off"
              },
              showCancelButton: true,
              confirmButtonText: "Cambiar",
              cancelButtonText: "Cancelar"
            })
            .then(result => {
              if (result.value) {
                this.dataMaterial.name = result.value;
                return MaterialService.save(this.dataMaterial);
              } else {
                this.dataMaterial.name = this.dataMaterial.title;
                return MaterialService.save(this.dataMaterial);
              }
            })
            .then(response => {
              this.$root.triggetSuccessMgs(
                "Excelente",
                "Se ha actualizado correctamente"
              );
            });
        } else {
          //Abrir modal para elegir el directorio donde se guardará
          this.tgModalSaveAs = true;
        }
      } else if (typeAction == "edit") {
        let data = {
          query: { _id: this.dataMaterial._id },
          data: this.dataMaterial
        };
        MaterialService.edit(data).then(response => {
          this.$root.triggetSuccessMgs(
            "Excelente",
            "Se ha actualizado correctamente"
          );
        });
      }
    },
    chooseMateria(materia) {
      this.dataMaterial.materia = materia._id;
      this.$refs["modal-choose-materia"].hide();
      MaterialService.save(this.dataMaterial).then(response => {
        this.dataMaterial = response;
        this.$root.triggetSuccessMgs(
          "Excelente",
          "Se ha guardado correctamente"
        );
      });
    },
    /*resetFiltro() {
    }*/
  },
  mounted() {
    setTimeout(() => {
      this.loadingPage = false;
    }, 500);
    let body = document.getElementsByTagName("body");
    body[0].classList.add("aside-menu-show");
    body[0].classList.add("sidebar-lg-show");
  },
  computed: {
    elements: {
      get() {
        return this.$store.getters["constructor/getBodyElements"];
      },
      set(value) {
        this.$store.dispatch("constructor/updateOrders", value);
      }
    },
    forUpdate() {
      return this.$store.getters["constructor/forUpdate"];
    }
  },
  watch: {
    titleEditor: function(change) {
      this.$store.dispatch("constructor/updateTitleOrDesc", { title: change });
    },
    descEditor: function(change) {
      this.$store.dispatch("constructor/updateTitleOrDesc", { desc: change });
    },
    color: function(change) {
      this.$store.dispatch("constructor/updateTitleOrDesc", { color: change });
    }
  },
  beforeMount() {
    if (this.$route.params.id != undefined) {
      var paramsList = {
        filtro: {}
      };
      paramsList.filtro._id = this.$route.params.id;
      MaterialService.list(1, paramsList).then(response => {
        let infoMaterial = JSON.parse(JSON.stringify(response[0]));
        delete infoMaterial.content;
        this.$store.dispatch("constructor/setInfo", infoMaterial);
        this.$store.dispatch("constructor/updateOrders", response[0].content);
      });
    }
  },
  beforeCreate() {
    console.log("antes de crear", this.$route.params.id);
    console.log("loading before created:", this.loadingPage);
  },
  created() {
    console.log("NAME::", this.$route.name);
    this.$store.dispatch("constructor/updateTitleOrDesc", {
      title: this.titleEditor
    });
    this.$store.dispatch("constructor/updateTitleOrDesc", {
      desc: this.descEditor
    });
    this.$store.dispatch("constructor/updateTitleOrDesc", {
      color: this.color
    });
  }
};
/* se modifico el package de npm que viene dentro de ckeditor5 en node modules, se instalo el plugin de fuente con npm dentro de la carpeta que se descomprime en node modules
pero aun así, pero aunque se importe las propiedaddes no las obtiene desde ahí*/
</script>
<style lang="scss">
@import "~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css";
.float {
  position: fixed;
  width: 130px;
  height: 130px;
  bottom: 50px;
  right: 250px;
  text-align: center;
}

.my-float {
  font-size: 25px;
  margin-top: 18px;
}

.label-container {
  position: fixed;
  bottom: 55px;
  right: 260px;
  display: table;
  visibility: hidden;
}

.label-text {
  color: #fff;
  background: rgba(51, 51, 51, 0.5);
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  border-radius: 3px;
}

.label-arrow {
  display: table-cell;
  vertical-align: middle;
  color: #333;
  opacity: 0.5;
}

a.float + div.label-container {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s ease;
}

a.float:hover + div.label-container {
  visibility: visible;
  opacity: 1;
}

.constructor-area {
  height: auto;
  border-style: dashed;
  border-radius: 0.3rem;
  border-color: #d6d6d6;
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.swatches {
  width: 49px;
  border: 3px solid black;
  margin: 0px;
  padding: 0px !important;
  height: 49px;
}

#cabecera {
  min-height: 100px;
}

#mainContainer {
  min-height: 100px;
  //cursor: pointer;
}

#pie {
  min-height: 80px;
}

.actividad-input {
  margin: 10px 0 10px 0;
  border: none;
}

.actividad-input:focus {
  border: none;
  box-shadow: none !important;
  border-bottom: 1px solid #bbbbbb !important;
  border-radius: 0;
}

.actividad-input:active {
  border: none;
  box-shadow: none !important;
  border-bottom: 1px solid #bbbbbb !important;
  border-radius: 0;
}

.actividad-pre-container {
  margin: 20px 0 20px 0;
  color: #bbbbbb;
}

.actividad-pre-container > .text-center > i {
  font-size: 32px;
}

.actividad-list-elementos > li.nav-item > a.nav-link {
  padding: 0;
}

.btn-add-element {
  max-width: 160px;
  padding: 0.5rem;
  cursor: pointer;
  margin: auto;
  color: #4dbd74;
  transition: all 0.4s ease;
  border: solid 1px transparent;

  &:hover {
    background: rgba(209, 240, 220, 0.5);
    border: solid 1px rgba(165, 232, 188, 0.5);
  }
}
.card-header-action:hover {
  color: #e3f9ff;
}
.text-tiny {
  font-size: 0.7em;
}

.text-small {
  font-size: 0.85em;
}

.text-big {
  font-size: 1.4em;
}

.text-huge {
  font-size: 1.8em;
}
.empty-folder {
  margin-top: 6rem;

  svg,
  p {
    text-align: center;
    color: #a3a9ad;
  }

  p {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.icon-hand-right {
  vertical-align: middle;
  margin-left: 20px;
}
.titulo-main > div.ck {
  padding: 0 5px !important;
}
</style>